import { render, staticRenderFns } from "./MainVideo2.vue?vue&type=template&id=28ee1023&"
import script from "./MainVideo2.vue?vue&type=script&lang=js&"
export * from "./MainVideo2.vue?vue&type=script&lang=js&"
import style0 from "./MainVideo2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainVideo2.vue"
export default component.exports